import Vue from "vue";
import * as MUTATIONS from "../config/constants/mutation-types";
import deepmerge from "deepmerge";

export default {
  // Evento publicado a los proveedores de seguimiento, sin modificar el estado.
  [MUTATIONS.ON_INICIAR_SOLICITUD]: () => {},
  /**
   * Mutation tcode
   * @param {Object} state
   * @param {Object} payload
   */
  [MUTATIONS.ON_TCODE]: (state, payload) => {
    Vue.set(state, "tcode", payload);
  },
  /**
   * Mutation llamada por el router
   * Ponemos la ruta en el state
   * @param {Object} state
   * @param {Object} payload
   */
  [MUTATIONS.ON_ROUTE]: (state, payload) => {
    Vue.set(state, "route", payload);
  },
  /**
   * Mostrar u ocultar el loader
   * @param {Object} context
   * @param {Boolean} payload estado
   */
  [MUTATIONS.ON_IS_LOADING]: (state, payload) => {
    Vue.set(state, "isLoading", !!payload);
  },
  [MUTATIONS.ON_LOADER_CONTENT]: (state, payload) => {
    const { loaderTitle, loaderText } = payload;
    Vue.set(state, "loaderTitle", loaderTitle);
    Vue.set(state, "loaderText", loaderText);
  },
  /**
   * Setear el monto solicitado como monto maximo
   * @param {Object} context
   * @param {Boolean} payload estado
   */
  [MUTATIONS.SET_MAX_AMOUNT]: (state, payload) => {
    Vue.set(state.consultaHipotecario, "montoSolicitado", payload);
  },
  [MUTATIONS.ON_NOTIFICATION_TOAST]: (state, payload) => {
    Vue.set(state, "notificationToast", payload);
  },
  /**
   * Mutation disparadas por el
   * step navigator para avanzar pasos
   * Cada action guarda el paso
   * actual en el store
   * @param {Object} state
   */
  [MUTATIONS.ON_LANDING]: (state, payload) => {
    Vue.set(state, "landing", payload);
  },
  [MUTATIONS.ON_GRACIAS]: (state, payload) => {
    Vue.set(state, "gracias", payload);
  },
  [MUTATIONS.ON_PASO1]: (state, payload) => {
    const paso1 = deepmerge({}, payload);
    Vue.set(state, "paso1", paso1);
    state.isLoading = false;
    //El domicilio será requerido en la entrega de la tarjeta
    //Por esto modifico el state de ese paso
    state.entrega.domicilioParticular = paso1.domicilioParticular;
  },
  [MUTATIONS.ON_NORMALIZE_ALTERNATIVO]: (state, payload) => {
    state.isLoading = false;
    state.entrega.otroDomicilio = payload;
    state.entrega.otroDomicilio.valido = true;
  },
  [MUTATIONS.ON_NORMALIZE_PARTICULAR]: (state, payload) => {
    state.isLoading = false;
    state.paso1.domicilioParticular = payload;
    state.entrega.domicilioParticular = payload;
    state.entrega.domicilioParticular.valido = true;
  },
  [MUTATIONS.ON_PASO2]: (state, payload) => {
    Vue.set(state, "paso2", payload);
  },
  [MUTATIONS.ON_SUCURSALES]: (state, payload) => {
    Vue.set(state, "sucursales", payload);
    Vue.set(state, "isLoading", false);
  },
  [MUTATIONS.ON_PASO3]: (state, payload) => {
    Vue.set(state, "paso3", payload);
  },
  [MUTATIONS.ON_FORZAR_DNE]: (state, force) => {
    Vue.set(state, "forzarDNE", Object.assign({}, state.forzarDNE, force));
  },
  [MUTATIONS.ON_ERROR]: (state, payload) => {
    state.error = payload;
    state.valid = false;
  },
  [MUTATIONS.ON_OFERTA]: (state, payload) => {
    // Agrego validación para que el recalculo no elimine
    // este resultado de la primer consulta
    if (state.esCliente == null) {
      state.esCliente = payload.esCliente;
    }
    state.simulacion = payload;
    state.valid = true;
  },
  [MUTATIONS.ADOBE_INTERNAL_LINK]: () => {},
  [MUTATIONS.ADOBE_APPSTARTED]: () => {},
  [MUTATIONS.ADOBE_HIPOTECARIO_PAGE_VISIT]: () => {},
  [MUTATIONS.ADOBE_CALCULADORA_VALOR_STEP_2]: () => {},
  [MUTATIONS.ADOBE_CALCULADORA_VALOR_STEP_3]: () => {},
  [MUTATIONS.ADOBE_CALCULADORA_VALOR_STEP_4]: () => {},
  [MUTATIONS.ADOBE_CALCULADORA_VALOR_STEP_5]: () => {},
  [MUTATIONS.ADOBE_APP_ON_CLICK_START]: (state, payload) => {
    Vue.set(state, "trackOnClickStart", payload);
  },
  [MUTATIONS.ON_PRELOAD_SDK](state, payload) {
    Vue.set(state.sdk, "preload", payload);
  },
  [MUTATIONS.ON_IS_VISIBLE_SDK](state, payload) {
    Vue.set(state.sdk, "isVisible", payload);
  },
  [MUTATIONS.ON_SAVE_IFRAME](state, payload) {
    Vue.set(state.sdk, "iframe", payload);
  },
  [MUTATIONS.ON_CONTADOR_MERLIN](state) {
    state.contadorLlamadosMerlin += 1;
  },
  [MUTATIONS.ON_RESET_CONTADOR_MERLIN](state) {
    state.contadorLlamadosMerlin = 0;
  },
  [MUTATIONS.ON_IS_BTD3](state, payload) {
    state.isBTD3 = payload;
  },
  [MUTATIONS.ON_LOGIN](state, payload) {
    Vue.set(state.dataVeridas, "key", payload.key);
  },
  [MUTATIONS.ON_DIA_DEBITO](state, payload) {
    Vue.set(state, "paso5", payload);
  },
  [MUTATIONS.ON_ENTREGA](state, payload) {
    Vue.set(state, "entrega", payload);
  },
  [MUTATIONS.ON_FIRMA_CONTRATOS](state) {
    Vue.set(state, "contratosFirmados", true);
  },
  [MUTATIONS.ON_PASO8](state, payload) {
    Vue.set(state, "paso8", payload);
  },
  [MUTATIONS.ON_CONTRATACION](state, payload) {
    Vue.set(state, "respuestaContratacion", payload);
    Vue.set(state, "contratacionFinalizada", true);
  },
  [MUTATIONS.ON_THANKS_VERIDAS](state, payload) {
    Vue.set(state.dataVeridas, "thanksVeridas", payload);
  },
  [MUTATIONS.ON_RESPONSE_VERIDAS](state, payload) {
    Vue.set(state.dataVeridas, "response", payload);
  },
  [MUTATIONS.ON_BIOMETRIA_POSITIVO](state, payload) {
    Vue.set(state.dataVeridas, "response", payload);
  },
  [MUTATIONS.ON_ERROR_VERIDAS]: (state, payload) => {
    // No reemplazar el error si ya existe y estoy enviando uno nuevo
    // Si reemplazar si estoy reseteando el error
    if ((!state.errorVeridas && payload) || payload === "") {
      state.errorVeridas = payload;
    }
  },
  [MUTATIONS.ON_RESULT_VERIDAS](state, payload) {
    Vue.set(state.dataVeridas, "response", payload);
  },
  [MUTATIONS.ON_ACTUALIZAR_ESTADO_TYC]: state => {
    Vue.set(state.biometria, "aceptoTerminos", true);
  },
  [MUTATIONS.ON_DIGITAL](state, payload) {
    state.paso4 = payload;
  },
  [MUTATIONS.ON_CONSULTA_CONTRATO](state, payload) {
    Vue.set(state.dataVeridas, "contracts", payload);
  },
  [MUTATIONS.ON_CONSULTA](state, payload = {}) {
    Vue.set(state, "contratacionFinalizada", false);
    state.consulta = Object.assign({}, state.consulta, payload);
    state.consulta.completed = true;
    // Volvemos el elemento clickeado a null para volver a disparar app started
    state.trackClickElement = null;
    // Seteo email por defecto para resumen digital
    state.paso4.resumenDigitalEmail =
      state.paso4.resumenDigitalEmail !== ""
        ? state.paso4.resumenDigitalEmail
        : payload.email;
  },
  /**
   * Mutation que permite a Adobe Target inyectar en el store
   * el código de la actividad que debe seleccionarse
   * @uso (desde afuera): BBVA_TC.$store.dispatch('SET_ADOBE_TARGET_EXPERIENCE', 'AR062019_B')
   */
  [MUTATIONS.ON_ADOBE_TARGET_EXPERIENCE]: (state, payload) => {
    state.adobeTargetExperience = payload;
  },
  [MUTATIONS.ON_FUNNEL_ERROR](state, payload) {
    // Acá queremos guardar el error al state pero no queremos
    // Que el usuario vuelva a completar la consulta
    Vue.set(state, "error", payload);
  },
  [MUTATIONS.ON_CREAR_USUARIO]: (state, payload) => {
    Vue.set(state, "paso6", payload);
  },
  [MUTATIONS.ON_VALIDAR_CELULAR]: (state, payload) => {
    Vue.set(state, "paso7", payload);
  },
  [MUTATIONS.ON_OTP_ONE](state, payload) {
    state.paso7.primerosDigitos = payload.otp;
    state.paso7.deviceUdid = payload.deviceUdid;
    state.paso7.error = false;
  },
  [MUTATIONS.ON_OTP_ERROR]: state => {
    Vue.set(state.paso7, "error", true);
  },
  [MUTATIONS.ADOBE_ERROR]: () => {},
  [MUTATIONS.ON_NORMALIZARCELULAR](state, payload) {
    state.consulta.celular.normalizado = {
      ...state.consulta.celular.normalizado,
      ...payload
    };
  },
  [MUTATIONS.ON_USER_ID_TOKENIZADO]: (state, payload) => {
    state.userIdTokenizado = payload;
  },
  [MUTATIONS.ON_DEVICEID]: (state, payload) => {
    state.deviceId = payload;
  },
  [MUTATIONS.ON_DEVICEIDTIMESTAMP]: (state, payload) => {
    state.deviceIdTimestamp = payload;
  },
  [MUTATIONS.ON_CLEAR_CONSULTA_PH]: state => {
    const emptyConsultaPH = {
      valorPropiedad: "",
      montoSolicitado: "",
      plazo: "30",
      destino: "1",
      cuentaSueldo: "",
      etapa: "",
      ingresos: ""
    };
    Vue.set(state, "consultaHipotecario", emptyConsultaPH);
  },
  [MUTATIONS.ON_LINEAS_PH]: (state, payload) => {
    Vue.set(state, "lineasPH", payload);
  },
  [MUTATIONS.ON_CONSULTA_PH]: (state, payload) => {
    Vue.set(state, "simulacion", payload);
    Vue.set(state, "valid", true);
  },
  [MUTATIONS.ON_CONFIRMAR_SIMULACION_PH]: (state, payload) => {
    Vue.$log.info(payload);
    Vue.set(state, "envioMailPH", payload);
  },
  [MUTATIONS.ON_TOGGLE_TERMS_AND_CONDITIONS]: (state, payload) => {
    Vue.set(state, "isTermsVisible", payload);
  },
  [MUTATIONS.SET_CONSULTA_PAYLOAD]: (state, payload) => {
    state.consultaPayload = payload;
  },
  [MUTATIONS.SET_RENAPER_CALLED]: (state, flag) => {
    state.renaperCalled = flag;
  },
  [MUTATIONS.ON_FECHA_SISTEMA]: (state, payload) => {
    state.fechaSistema = payload;
  },
  [MUTATIONS.ON_COTIZACION]: (state, payload) => {
    state.cotizacion = payload;
  },
  [MUTATIONS.SET_DVS_IFRAME_DATA](state, payload) {
    Vue.set(state, "DVSIframeData", payload);
  },
  [MUTATIONS.ON_DATA_AUTH_ASO](state, payload) {
    Vue.set(state, "dataAuthASO", payload);
  },
  [MUTATIONS.ON_PRESCRIPTOR](state, payload) {
    state.precriptor = payload;
  },
  [MUTATIONS.ON_RESET_FORM]: state => {
    state.consulta.nombre = "";
    state.consulta.apellido = "";
    state.consulta.tipoDocumento = "00";
    state.consulta.numeroDoc = "";
    state.consulta.nacionalidad = "";
    state.consulta.fechaNacimiento = "";
    state.consulta.sexo = "F";
    state.consulta.celular = {
      area: "",
      numero: "",
      normalizado: {
        area: "",
        caracteristica: "",
        nro: "",
        interno: "",
        valido: null
      },
      compania: ""
    };
    state.consulta.email = "";
    state.consultaHipotecario.etapa = "";
  },
  [MUTATIONS.SET_LANDING_QR_URL](state, shortUrl) {
    state.landingQrUrl = shortUrl;
  },
  [MUTATIONS.UPDATE_CONSULTA]: (state, payload) => {
    Object.keys(payload).forEach(key => {
      if (Object.hasOwn(state.consulta, key)) {
        Vue.set(state.consulta, key, payload[key]);
      }
    });
  },
  [MUTATIONS.UPDATE_OFERTA]: (state, payload) => {
    Object.keys(payload).forEach(key => {
      if (Object.hasOwn(state.oferta, key)) {
        Vue.set(state.oferta, key, payload[key]);
      }
    });
  }
};
